import React from 'react';
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import RouteWithSubRoutes from '../router/config.js';
import Navigation from '../components/nav.js';
import Footerontainer from '../components/footer.js';
// import { NavLink, Link } from 'react-router-dom';

const url = "/activities"

@connect(
	(state, props) => ({
		getState: state
	})
)

export default class App extends React.Component {
	state = {
		url: '/',
		show: true,
		show_: false,
		show__: true
	}
	constructor(props) {
		super(props);
		this.closeEvent = this.closeEvent.bind(this);
		this.closeEvent_ = this.closeEvent_.bind(this);
		this.tipEvent = this.tipEvent.bind(this);
		this.urlEvent = this.urlEvent.bind(this);
	}
	componentDidMount() {

	}
	componentWillUnmount() {
		// 清除事件处理函数
	}
	urlEvent(e, url) {
		e.stopPropagation();
		this.setState({ show: false });
		this.setState({ show_: false });
		this.setState({ show_: false });
	}
	closeEvent() {
		this.setState({ show: false });
	}
	closeEvent_() {
		this.setState({ show_: false });
		this.setState({ show__: false });
	}
	tipEvent() {
		this.setState({ show_: true });
	}

	// // 临时活动，PMS大放价，0.99邮英国，4天签收弹出蒙层
	// activitiesBox() {
	// 	let activitiesBG = null;
	// 	if (this.state.show) {
	// 		activitiesBG = <div className='activitiesBox animated fadeIn'>
	// 			<div className='activitiesInn'></div>
	// 			<Link to={url} className='activitiesEvent' onClick={this.urlEvent}></Link>
	// 			<span className='activitiesIcon' onClick={this.closeEvent}></span>
	// 		</div>
	// 	}
	// 	return (
	// 		<div>{activitiesBG}</div>
	// 	)
	// }

	// activitiesMsg() {
	// 	let activitiesBG = null;
	// 	if (!this.state.show_) {
	// 		activitiesBG = <div className='activitiesTip animated fadeIn' onMouseOver={this.tipEvent}></div>
	// 	}
	// 	if (this.state.show__) {
	// 		activitiesBG = <div className='activitiesMsg'>
	// 			<img src={require('../assets/image/activities/activitiesMsg.png')} alt="" />
	// 			<Link to={url} onClick={this.urlEvent}><span className='activitiesIcon__'></span></Link>
	// 			<span className='activitiesIcon_' onClick={this.closeEvent_}></span>
	// 		</div>
	// 	}
	// 	if (this.state.show_) {
	// 		activitiesBG = <div className='activitiesMsg animated slideInLeft'>
	// 			<img src={require('../assets/image/activities/activitiesMsg.png')} alt="" />
	// 			<Link to={url} onClick={this.urlEvent}><span className='activitiesIcon__'></span></Link>
	// 			<span className='activitiesIcon_' onClick={this.closeEvent_}></span>
	// 		</div>
	// 	}
	// 	return (
	// 		<div>{activitiesBG}</div>
	// 	)
	// }

	render() {
		const { routes, getState } = this.props;
		return (
			<div>
				<Navigation language={getState.CommonReducer.language}></Navigation>
				<div>
					{routes.map((route, i) => (
						<RouteWithSubRoutes language={getState.CommonReducer.language} key={i} {...route} />
					))}
				</div>
				<Footerontainer language={getState.CommonReducer.language}></Footerontainer>
				{/* {this.activitiesBox()} */}
				{/* {this.activitiesMsg()} */}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./public/views/index.js